import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { MuiSvgProps } from "../../types";

const Home = (props: MuiSvgProps) => (
  <SvgIcon {...props} viewBox="0 0 19.8 16.2">
    <path
      fill={props.fill ? props.fill : "#1280E7"}
      d="M3.176 16.313V7.875l-1.62 1.238-1.08-1.44 2.7-2.07v-2.79h1.8V4.23l5.4-4.117 9.9 7.56-1.08 1.417-1.62-1.215v8.438h-14.4Zm1.8-1.8h4.5v-3.6h1.8v3.6h4.5v-8.01l-5.4-4.118-5.4 4.118v8.01Z"
    />
  </SvgIcon>
);

export default Home;
